import React, { useState } from "react";
import {
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from "@material-ui/core";
import { useMutation } from "@apollo/client";
import { addModuleOrderMutation } from "./ModulesGqlQuery";

const AddModule = (props) => {
  const [addModuleOrder] = useMutation(addModuleOrderMutation);
  const [moduleDisplayName, setModuleDisplayName] = useState("");
  const [moduleName, setModuleName] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();

    const moduleNameValue = moduleName.trim();
    const moduleDisplayNameValue = moduleDisplayName.trim();

    if (!moduleNameValue || !moduleDisplayNameValue) {
      return;
    }

    addModuleOrder({
      variables: {
        modules: {
          moduleName: moduleNameValue,
          moduleDisplayName: moduleDisplayNameValue,
        },
      },
    })
      .then(() => {
        if (props.onSuccess) {
          props.onSuccess({
            moduleName: moduleNameValue,
            moduleDisplayName: moduleDisplayNameValue,
          });
        }
      })
      .catch((error) => {
        if (error.graphQLErrors && error.graphQLErrors.length > 0) {
          setErrorMessage(error.graphQLErrors[0].message);
        }
      });
  };

  return (
    <form onSubmit={handleSubmit}>
      <DialogContent>
        <TextField
          label="Module Name"
          value={moduleName}
          onChange={(event) => {
            setModuleName(event.target.value);
          }}
          variant="outlined"
          size="small"
          fullWidth
          //   autoFocus
          style={{ marginBottom: 16 }}
        />
        <TextField
          label="Module Display Name"
          value={moduleDisplayName}
          onChange={(event) => {
            setModuleDisplayName(event.target.value);
          }}
          variant="outlined"
          size="small"
          fullWidth
          //   autoFocus
        />

        {errorMessage && (
          <div style={{ color: "red", marginTop: 8 }}>{errorMessage}</div>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={props.handleClose} color="primary">
          Cancel
        </Button>

        <Button
          type="submit"
          color="primary"
          disabled={!moduleName.trim() && !moduleDisplayName.trim()}
        >
          Save
        </Button>
      </DialogActions>
    </form>
  );
};

export default AddModule;
